var _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.0002,
    cy: 46.9999,
    r: 31.2907,
    stroke: "#A8CCFF",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 46.5,
    stroke: "#A7A9BD",
    strokeOpacity: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.0002,
    cy: 47,
    r: 36.6628,
    stroke: "#A7A9BD",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8016 37.9689C46.9016 37.8381 47.0987 37.8381 47.1987 37.9689L53.7975 46.5981C53.9233 46.7626 53.806 46.9999 53.5989 46.9999H49.9827C49.8446 46.9999 49.7327 47.1119 49.7327 47.2499V55.4941C49.7327 55.6322 49.6208 55.7441 49.4827 55.7441H44.5176C44.3795 55.7441 44.2676 55.6322 44.2676 55.4941V47.2499C44.2676 47.1119 44.1557 46.9999 44.0176 46.9999H40.4014C40.1943 46.9999 40.077 46.7626 40.2028 46.5981L46.8016 37.9689Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.27932b844e7cf7355c3e6ab5c5dbfbb7.svg";
export { ForwardRef as ReactComponent };